module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_8017.2c73c7d8.png";